// eslint-disable-next-line no-shadow
export enum InputFieldTypesEnum {
  Email = 'email',
  Text = 'text',
  Number = 'number',
  Password = 'password'
}
